"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'profession.search.placeholder': 'Search professions...',
};
